import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthSessionService } from '../services/auth-session.service';

export const guestGuard: CanActivateFn = (): boolean | UrlTree => {
  const auth = inject(AuthSessionService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) return true;

  if (auth.hasPrincipalAccess()) return router.createUrlTree(['/principal/dashboard']);
  return router.createUrlTree(['/teacher/dashboard']);
};
